module.exports = __webpack_public_path__ + "static/media/logoBannerTopWEBM.8d009512.webm";